import { ProposalAction } from "../../buy/constants/buy-basic-data";
import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { JobAction } from "../../keep/constants/keep-basic-data";
import { BookingAction } from "../../rent/constants/rent-basic-data";
import { TransactionRole } from "../constants/common-basic-data";
import { ObjectSource } from "../constants/general-basic-data";


export class ObjectData {
    objectSource: ObjectSource = ObjectSource.DEALER;
    offerId = '';
    objectId = 0;
    itemId = 0;
    businessLine: CarBusinessLine = CarBusinessLine.BUY
    carId = '';

    transactionRole: TransactionRole = TransactionRole.CUSTOMER;
    
    objectAction?: ProposalAction | BookingAction | JobAction;

    constructor (objectSource: ObjectSource, offerId: string, objectId: number, businessLine?: CarBusinessLine, carId?: string)  {
      this.objectSource = objectSource!;
      this.carId = carId!;
      this.offerId = offerId!;
      this.objectId = objectId!;
      this.businessLine = businessLine!;
    }
  }